import type { Board } from "../board";
import type { Direction } from "../direction";
import { ALL_DIRECTIONS, directionDelta } from "../direction";
import type { Player } from "../player";
import { Missile } from "../projectiles/missile";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class MissileBurst extends Weapon {
	static key = "MissileBurst";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.LAUNCHER;
	}

	fire(_direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_MISSILE));
		for (const dir of ALL_DIRECTIONS) {
			const spawnPos = this.owner.xy.add(directionDelta(dir));
			const missile = new Missile(spawnPos, dir);
			this.shotProjectile(board, missile);
		}
	}

	static deserialize(data: any, owner: Player): MissileBurst {
		const gun = new MissileBurst(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
